module.exports = __webpack_public_path__ + "img/ic_manager_reply_rate.77214d0e.png";